<template>
    <div>
        <transition-group name="videos" tag="div" class="tabs d-flex flex-wrap justify-content-around">
            <div class="video-tab d-flex flex-column" v-for="video in videos.filter(item => item.category === category || !category)" :key="video.id">
                <div class="video">
                    <div class="pre" @click="showModal = true; selectedVideo = video">
                        <img :src="require('@/assets/images/instructions/' + (video.instructions[1] ? video.instructions[1].image : video.instructions[0].image))" height="100%" width="100%" alt="">
                        <div class="pre-1">
                            <img src="../../assets/images/play-button.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="tab-info flex-grow-1">
                    <h2>{{ video.title }}</h2>
                    <p class="d-none">{{ video.description }}</p>
                </div>
                <div class="view-instruction my-3">
                    <w-button class="px-2 px-sm-4" :to="{ path: `/help/${video.id}` }">
                        View Instructions
                    </w-button>
                </div>
            </div>
        </transition-group>
        <w-modal v-if="showModal" @close="showModal = false" size="lg">
            <h3 slot="header">{{selectedVideo.title}}</h3>
            <help-video @viewAll="viewAll" @change="videoChanged" slot="body" :id="selectedVideo.id"></help-video>
        </w-modal>
    </div>
</template>

<script>
import videos from '@/assets/json/videos.json'
import HelpVideo from './HelpVideo'

export default {
    name: 'HelpVideos',
    data () {
        return {
            showModal: false,
            selectedVideo: {}
        }
    },
    methods: {
        videoChanged (id) {
            this.selectedVideo = videos.find(item => item.id === id)
        },
        viewAll () {
            this.showModal = false
            this.$router.push('/help')
        }
    },
    computed: {
        videos () {
            return videos.sort((a, b) => a.order - b.order)
        },
        category () {
            return this.$route.query.category
        }
    },
    components: {
        HelpVideo
    }
}
</script>

<style scoped>
    .video-tab {
        transition: all 1s;
        display: inline-block;
        position: relative;
        color: #2fc2ef;
    }

    .view-instruction {
        width: 100%;
    }

    .tabs > div {
        width: 245px;
        margin-bottom: 20px;
        border: 2px solid #9f9f9f;
    }

    .tabs .video {
        width: 100%;
        height: 155px;
        background-color: #bdbdbd;
        overflow: hidden;
        position: relative;
        border-bottom: 2px solid #9f9f9f;
    }

    .tabs .video .pre {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }

    .tabs .tab-info {
        position: relative;
        padding: 0 25px;
    }

    .tabs .tab-info h2 {
        margin-top: 20px;
        font-size: 22px;
        font-weight: 400;
    }

    .tabs .tab-info p {
        font-size: 14px;
    }

    .tabs .video .pre-1 {
        width: 55px;
        height: 35px;
        position: absolute;
        background-color: rgba(0, 0, 0, .7);
        top: 50%;
        left: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(-50%, -50%);
        border-radius: 5px;
        cursor: pointer;
    }

    .tabs .tab-info p {
        display: -webkit-box !important;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (min-width: 576px) {
        .tabs .tab-info p {
            line-height: 17px;
        }
    }

    @media (max-width: 576px) {
        .video-tab {
            width: 49% !important;
            /*height: 220px !important;*/
            margin-right: 1% !important;
        }

        .tabs .video {
            height: 90px;
        }

        .view-instruction {
            bottom: 10px;
            width: 100%;
            text-align: center;
            margin: 0;
        }

        .tab-info > p {
            display: none;
            margin-bottom: 0;
        }

        .tabs .tab-info h2 {
            margin-top: 8px;
            font-size: 18px;
            font-weight: 400;
        }

        .tabs .tab-info {
            padding: 0 15px;
        }
    }

    /*Animations*/

    .videos-enter {
        opacity: 0;
        transform: translateY(300px);
    }

    .videos-leave-to {
        opacity: 0;
        transform: translateY(300px);
    }

    .videos-leave-active {
        position: absolute;
    }
</style>
